import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { IconButton } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import PhotoCameraRoundedIcon from "@material-ui/icons/PhotoCameraRounded";
import { GridLoader as Spin } from "react-spinners";
import MediaControl from "../MediaControl/mediaControl.component";

import { useStyles } from "./camStyle";

// import extract from "../../utils/modelUtils/tesseractOffline";
// import extract from "../../utils/modelUtils/tesseractOnline";
import Tesseract from "tesseract.js";

const Cam = () => {
  const classes = useStyles();
  const [source, setSource] = useState("");
  let [loading, setLoading] = useState(false);
  const [AmharicText, setAmharicText] = useState("");

  // to manage change of text on image text
  useEffect(() => {
    // method to recognize from Tesseract calls
    Tesseract.recognize(source, "amh").then(({ data: { text } }) => {
      setAmharicText(text);
      setLoading(false);
    });
    // extract(source).then(extracted => {
    //   setAmharicText(extracted)
    //   setLoading(false);
    // });
  }, [source]);

  const handleCapture = (target) => {
    if (target.files) {
      if (target.files.length !== 0) {
        const file = target.files[0];
        const newUrl = URL.createObjectURL(file);

        setSource(newUrl);
      }
    }
  };

  return (
    <div className={classes.root}>
      <center>
        <Grid container alignItems="center">
          <Grid item sm={6}>
            <h4>Take a picture</h4>
            <center>
              {source && (
                <Box
                  display="flex"
                  justifyContent="center"
                  border={1}
                  className={classes.imgBox}
                >
                  <img
                    src={source}
                    alt={"snap captured"}
                    className={classes.img}
                  ></img>
                </Box>
              )}
            </center>
            <input
              accept="image/*"
              className={classes.input}
              id="icon-button-file"
              type="file"
              capture="environment"
              onChange={(e) => {
                handleCapture(e.target);
                setLoading(!loading);
              }}
            />
            <label htmlFor="icon-button-file">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCameraRoundedIcon fontSize="large" color="primary" />
              </IconButton>
            </label>
          </Grid>

          <Grid className={classes.textBox} item sm={6}>
            <TextField
              aria-label="captured text holder"
              id="outlined-multiline-static"
              label="OCR Captured Amharic"
              placeholder="Captured text"
              margin="dense"
              size="medium"
              multiline
              fullWidth="true"
              rows={16}
              defaultValue={AmharicText}
              value={AmharicText}
              variant="filled"
            />
          </Grid>
        </Grid>
        <center>
          <Spin
            loading={loading}
            color={"#3F51B5"}
            size={45}
            // height={75}
            // width={20}
            radius={2}
            // margin={5}
          />
          <br />
        </center>
        <MediaControl text={AmharicText} />
      </center>
    </div>
  );
};

export default Cam;
